import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

// Actions on a table row: quiet until the row is hovered or focused, so a long table
// does not read as a wall of buttons. PathwayTableContentRow drives the reveal.
const Actions = styled.span`
    display: inline-flex;
    justify-content: flex-end;
    gap: 6px;
    opacity: 0.65;
    transition: opacity var(--pw-transition-fast) var(--pw-ease);
`;

const PathwayRowActions = ({ children, dataCy }) => (
    <Actions className="pw-row-actions" data-cy={dataCy}>
        {children}
    </Actions>
);

PathwayRowActions.propTypes = {
    children: PropTypes.node.isRequired,
    dataCy: PropTypes.string,
};

export default PathwayRowActions;
